$(document).ready(function(){

	$('.slick-concept').slick({
		arrows:false,
		slidesToShow: 4,
		slidesToScroll: 1,
		accessibility:false,
		pauseOnHover:false,
		pauseOnFocus:false,
		draggable:false,
		autoplay: true,
		variableWidth: true,
		dots: false,
		lazyLoad:'progressive',
		cssEase: 'linear',
		autoplaySpeed: 0,
		speed:9000,
	});
	$('#top-news .article-image img').matchHeight();
	$('#top-news .article-title').matchHeight();
	$('#top-news .summary').matchHeight();
	$('#top-news article').matchHeight();
  	$('.footer-match').matchHeight();
});